
const PricingHero = () => {
  return (
    <div className="text-center mb-12">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">
        Simple, <span className="text-godyspo-gold">Transparent</span> Pricing
      </h1>
      <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
        Start your 30-day free trial today - no commitments, cancel anytime
      </p>
    </div>
  );
};

export default PricingHero;
